export enum MarkerIcon {
  airport = 'https://svgshare.com/i/EvE.svg',
  airportSelected = 'https://svgshare.com/i/Eu_.svg',
  hotel = 'https://svgshare.com/i/FBB.svg',
  hotelSelected = 'https://svgshare.com/i/FAc.svg',
  hotelNegarates = 'https://svgshare.com/i/FAs.svg',
  hotelNegaratesSelected = 'https://svgshare.com/i/FB2.svg',
  hotelGeniusRate = 'https://svgshare.com/i/FB3.svg',
  hotelGeniusRateSelected = 'https://svgshare.com/i/FAB.svg',
  railway = 'https://svgshare.com/i/DDK.svg',
  railwaySelected = 'https://svgshare.com/i/DCB.svg',
  transfer = 'https://svgshare.com/i/D6h.svg',
  transferSelected = 'https://svgshare.com/i/D6t.svg',
  port = 'https://svgshare.com/i/DHx.svg',
  portSelected = 'https://svgshare.com/i/DHV.svg',
  destination = 'https://svgshare.com/i/EFF.svg',
  destinationSelected = 'https://svgshare.com/i/EHe.svg',
  favorite = 'https://svgshare.com/i/FBC.svg',
  favoriteSelected = 'https://svgshare.com/i/Fot.svg',
  routeUnd = 'https://svgshare.com/i/ERn.svg',
  dropDown = 'https://svgshare.com/i/EGA.svg',
  pickUp = 'https://svgshare.com/i/EFz.svg',
}
